export default function Reviews() {
  const reviews = [
    {
      id: 1,
      name: '김민지',
      rating: 5,
      date: '2024.12.10',
      content: '시중 포도즙과는 확실히 다릅니다. 진한 포도 향과 자연스러운 단맛이 일품이에요. 아이들도 너무 좋아해서 재구매했습니다.',
      image: 'https://public.readdy.ai/ai/img_res/ef4517d6d3cd69af81e05841768b5b90.jpg'
    },
    {
      id: 2,
      name: '박준호',
      rating: 5,
      date: '2024.12.08',
      content: '무첨가라는 게 확실히 느껴집니다. 인공적인 맛이 전혀 없고 포도 본연의 맛이 살아있어요. 건강하게 마실 수 있어서 좋습니다.',
      image: 'https://readdy.ai/api/search-image?query=Male%20customer%20enjoying%20purple%20grape%20juice%20in%20modern%20kitchen%2C%20natural%20morning%20light%2C%20healthy%20lifestyle%20concept%2C%20authentic%20documentary%20style%20photography%2C%20clean%20simple%20background&width=400&height=400&seq=review-02&orientation=squarish'
    },
    {
      id: 3,
      name: '이서연',
      rating: 5,
      date: '2024.12.05',
      content: '검사성적서까지 공개하는 투명함이 마음에 들어 구매했습니다. 맛도 좋고 안심하고 마실 수 있어서 만족스럽습니다.',
      image: 'https://readdy.ai/api/search-image?query=Female%20customer%20reading%20product%20information%20on%20grape%20juice%20pouch%2C%20bright%20clean%20setting%2C%20trust%20and%20satisfaction%20concept%2C%20professional%20lifestyle%20photography%2C%20simple%20background&width=400&height=400&seq=review-03&orientation=squarish'
    },
    {
      id: 4,
      name: '최동욱',
      rating: 5,
      date: '2024.12.02',
      content: '저온 착즙이라 그런지 향이 정말 좋습니다. 운동 후에 마시면 피로가 확 풀리는 느낌이에요. 강력 추천합니다!',
      image: 'https://readdy.ai/api/search-image?query=Athletic%20person%20drinking%20purple%20grape%20juice%20after%20workout%2C%20energetic%20and%20refreshed%20expression%2C%20fitness%20lifestyle%20photography%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=review-04&orientation=squarish'
    },
    {
      id: 5,
      name: '정수민',
      rating: 5,
      date: '2024.11.28',
      content: '포장도 깔끔하고 파우치라 휴대하기 편해요. 맛은 말할 것도 없이 최고입니다. 선물용으로도 좋을 것 같아요.',
      image: 'https://readdy.ai/api/search-image?query=Customer%20showing%20purple%20grape%20juice%20pouch%20packaging%2C%20clean%20and%20organized%20presentation%2C%20product%20appreciation%20concept%2C%20professional%20lifestyle%20photography%2C%20simple%20background&width=400&height=400&seq=review-05&orientation=squarish'
    },
    {
      id: 6,
      name: '강태현',
      rating: 5,
      date: '2024.11.25',
      content: '화악산 암반수로 세척한다는 점이 특별하네요. 깨끗하고 신선한 맛이 느껴집니다. 계속 구매할 예정입니다.',
      image: 'https://readdy.ai/api/search-image?query=Satisfied%20customer%20with%20purple%20grape%20juice%20in%20home%20setting%2C%20genuine%20happiness%20and%20trust%2C%20natural%20lifestyle%20photography%2C%20warm%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=review-06&orientation=squarish'
    }
  ];

  const averageRating = 5.0;
  const totalReviews = 247;

  return (
    <section className="py-20 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            고객 후기
          </h2>
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-2xl text-yellow-400"></i>
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">{averageRating}</span>
            <span className="text-gray-600">({totalReviews}개 리뷰)</span>
          </div>
          <p className="text-lg text-gray-600">
            실제 구매 고객님들의 솔직한 후기입니다.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {reviews.map((review) => (
            <div 
              key={review.id}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-shadow"
            >
              <img 
                src={review.image}
                alt={`${review.name}님의 후기`}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-1">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <i 
                        key={star} 
                        className={`${star <= review.rating ? 'ri-star-fill text-yellow-400' : 'ri-star-line text-gray-300'} text-lg`}
                      ></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-500">{review.date}</span>
                </div>
                <p className="text-gray-700 leading-relaxed mb-4">
                  {review.content}
                </p>
                <p className="font-semibold text-gray-900">{review.name}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="inline-flex items-center gap-2 bg-white text-[#6B4E9C] px-8 py-4 rounded-lg font-bold text-lg border-2 border-[#6B4E9C] hover:bg-[#6B4E9C]/5 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-more-line"></i>
            더 많은 후기 보기
          </button>
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#6B4E9C]/10 to-purple-100/30 rounded-xl p-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            리뷰 작성 가이드
          </h3>
          <p className="text-gray-700">
            구매하신 제품의 솔직한 후기를 남겨주세요. 포토 리뷰 작성 시 추가 적립금을 드립니다.
          </p>
        </div>
      </div>
    </section>
  );
}